import { useQuery } from '@apollo/client';
import { PropsWithChildren, useEffect } from 'react';
import { GET_MEMBERSHIP_IS_EXPIRED } from './graphql/profile/queries';

interface RouteWrapperProps extends PropsWithChildren {
    handleMembershipExpiryStatus: (expired: boolean) => void;
}

export const RouteWrapper: React.FC<RouteWrapperProps> = ({
    handleMembershipExpiryStatus,
    children,
}) => {
    const { data, loading } = useQuery(GET_MEMBERSHIP_IS_EXPIRED, {
        fetchPolicy: 'no-cache',
    });

    useEffect(() => {
        if (data) handleMembershipExpiryStatus(data.membershipIsExpired);
    }, [data, loading, handleMembershipExpiryStatus]);

    return <>{children}</>;
};
